import { axiosApi } from './api'

export const event = axiosApi.injectEndpoints({
    endpoints: build => ({
        authSignalR: build.query({
            query: () => `oauth/SignalRConnection`,
            transformResponse: res => res,
        }),

        /*
         * GET event status by invoation id
         */
        getEvents: build.query({
            query: invocationId => `v1/bgprocessevents/${invocationId}`,
            transformResponse: res => res.data,
        }),
    }),
    overrideExisting: false,
})

export const { useGetEventsQuery, useAuthSignalRQuery } = event
